/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedModelOfPartnerModel } from '../model/paginatedModelOfPartnerModel';
import { PaginatedModelOfRelay } from '../model/paginatedModelOfRelay';
import { PartnerDto } from '../model/partnerDto';
import { PartnerModel } from '../model/partnerModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PartnerService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerDeletePartner(partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public partnerDeletePartner(partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public partnerDeletePartner(partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public partnerDeletePartner(partnerId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<string>(`${this.basePath}/api/Partner/DeletePartner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerGetAllPartnersBySPId(spId?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfPartnerModel>;
    public partnerGetAllPartnersBySPId(spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfPartnerModel>>;
    public partnerGetAllPartnersBySPId(spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfPartnerModel>>;
    public partnerGetAllPartnersBySPId(spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfPartnerModel>(`${this.basePath}/api/Partner/GetAllPartnersBySPId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param skip 
     * @param take 
     * @param keyword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerGetAllPartnersByServiceProviderId(spId?: string, skip?: number, take?: number, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerDto>;
    public partnerGetAllPartnersByServiceProviderId(spId?: string, skip?: number, take?: number, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerDto>>;
    public partnerGetAllPartnersByServiceProviderId(spId?: string, skip?: number, take?: number, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerDto>>;
    public partnerGetAllPartnersByServiceProviderId(spId?: string, skip?: number, take?: number, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerDto>(`${this.basePath}/api/Partner/GetAllPartnersByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerGetAllPartnersContentsByPartnerId(partnerId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfRelay>;
    public partnerGetAllPartnersContentsByPartnerId(partnerId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfRelay>>;
    public partnerGetAllPartnersContentsByPartnerId(partnerId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfRelay>>;
    public partnerGetAllPartnersContentsByPartnerId(partnerId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfRelay>(`${this.basePath}/api/Partner/GetAllPartnersContentsByPartnerId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param partnerGuiId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerGetPartnerbyId(partnerId?: number, partnerGuiId?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerModel>;
    public partnerGetPartnerbyId(partnerId?: number, partnerGuiId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerModel>>;
    public partnerGetPartnerbyId(partnerId?: number, partnerGuiId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerModel>>;
    public partnerGetPartnerbyId(partnerId?: number, partnerGuiId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }
        if (partnerGuiId !== undefined && partnerGuiId !== null) {
            queryParameters = queryParameters.set('partnerGuiId', <any>partnerGuiId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerModel>(`${this.basePath}/api/Partner/GetPartnerbyId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerInsertPartner(model: PartnerModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public partnerInsertPartner(model: PartnerModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public partnerInsertPartner(model: PartnerModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public partnerInsertPartner(model: PartnerModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling partnerInsertPartner.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Partner/InsertPartner`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partnerUpdatePartner(model: PartnerModel, observe?: 'body', reportProgress?: boolean): Observable<PartnerModel>;
    public partnerUpdatePartner(model: PartnerModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerModel>>;
    public partnerUpdatePartner(model: PartnerModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerModel>>;
    public partnerUpdatePartner(model: PartnerModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling partnerUpdatePartner.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<PartnerModel>(`${this.basePath}/api/Partner/UpdatePartner`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
